/* eslint-disable */
import React, { useState } from 'react';
import classNames from 'classnames';
import { HashLink as Link } from 'react-router-hash-link';
import { Container, NavbarBrand, Navbar, Nav, NavItem, NavbarToggler, Collapse, Col } from 'reactstrap';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const title = {
        transform: 'translate(-32%, 5%)',
    };

    const styles = {
        principal: {
            width: '100%',
            height: '1180px'
        },
        texto: {
            color: '#9B1B21',
            fontWeight: '300', 
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '19px',
            textShadow: '0.5px 0.5px 0.5px #000000'
        },
    }

    return (
        <div className="topbar" id="top">
            <div className="header6">
                <Container className="po-relative">
                    <Navbar className="navbar-expand-lg h6-nav-bar ">
                        <Col lg="3" md="6" className="align-self-center text-left">
                            <NavbarBrand href="/"><img style={title} src={'/logos/clioydike.png'} alt="wrapkit" width='140px' /></NavbarBrand>
                        </Col>
                        <Col lg="9" md="6" className="align-self-left text-left">
                            <NavbarToggler onClick={toggle}><span className="ti-menu"></span></NavbarToggler>
                            <Collapse isOpen={isOpen} navbar className="hover-dropdown font-14 ml-auto" id="h6-info">
                                <Nav navbar className="ml-auto">
                                    <NavItem>
                                        <Link className="nav-link font-16 m-2" style={styles.texto} to={"/index"}>
                                            Inicio
                                        </Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link className="nav-link font-16 m-2" style={styles.texto} to={"/listahistorias"}>
                                            Publicaciones
                                        </Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link className="nav-link font-16 m-2" style={styles.texto} to={"/#"}>
                                            Linea de Tiempo
                                        </Link>
                                    </NavItem>
                                    <NavItem>
                                        <a href="/login" className="btn btn-lg font-weight-bold font-14 m-t-30"
                                            style={{
                                                backgroundColor: '#821520',
                                                color: 'white',
                                                border: `2px solid #821520`,
                                                padding: '10px 25px',
                                                textTransform: 'uppercase'
                                            }}>
                                            Iniciar Sesión
                                        </a>
                                    </NavItem>
                                </Nav>
                            </Collapse>
                        </Col>
                    </Navbar>
                </Container>
            </div>
        </div>
    );

}
export default Header;
